import { FC, PropsWithChildren } from 'react';
import styles from '../notification-details.module.scss';
import { Notification } from 'services/notifications/types';
import cx from 'classnames';

interface NotificationDetailsContainerProps {
  item: Notification;
}

export const NotificationDetailsContainer: FC<
  PropsWithChildren<NotificationDetailsContainerProps>
> = ({ item, children }) => (
  <div
    className={cx(
      styles['notification-item'],
      'border-bottom border-LightGray d-flex d-row',
      {
        [styles['notification-item-hide']]: item?.isDismissed,
        [styles['notification-item-active']]: !item?.isRead
      }
    )}
    data-testid="notification-details"
  >
    <div
      className={cx(
        'd-flex d-column pe-3 w-100',
        styles['notification-item-padding']
      )}
    >
      <div className="w-100">
        <div className="u-fs--14">{children}</div>
      </div>
    </div>
  </div>
);
